import { FormattedMessage } from 'react-intl'

import { Button } from '@gto/ui/button'
import { Paper } from '@gto/ui/paper'
import { Typography } from '@gto/ui/typography'

type CouponBulkBarProps = {
  selectedCount: number
  /** Disables every action while a bulk write is in flight. */
  busy: boolean
  onActivate: () => void
  onDeactivate: () => void
  onEdit: () => void
  onClear: () => void
}

/**
 * The selection action bar above the admin Links table. Rendered only with a
 * non-empty selection, so it never occupies space in the default view.
 *
 * Activate / Deactivate are shortcuts for the single most common bulk edit;
 * anything more (tags, or both at once) goes through the edit dialog. Both
 * shortcuts are the same reversible `is_active` PATCH the row menu already
 * performs — there is deliberately no bulk delete.
 */
export const CouponBulkBar = ({
  selectedCount,
  busy,
  onActivate,
  onDeactivate,
  onEdit,
  onClear,
}: CouponBulkBarProps) => (
  <Paper
    className="flex flex-wrap items-center justify-between gap-3 rounded-md px-4 py-2"
    data-tst="coupon-bulk-bar"
    elevation="3"
  >
    <Typography variant="body2">
      <FormattedMessage
        id="admin.partnerDetail.coupons.bulk.selectedOnPage"
        values={{ count: selectedCount }}
      />
    </Typography>

    <div className="flex flex-wrap items-center gap-2">
      <Button
        data-tst="coupon-bulk-activate"
        disabled={busy}
        size="small"
        onClick={onActivate}
      >
        <FormattedMessage id="admin.partnerDetail.coupons.activate" />
      </Button>
      <Button
        color="error"
        data-tst="coupon-bulk-deactivate"
        disabled={busy}
        size="small"
        onClick={onDeactivate}
      >
        <FormattedMessage id="admin.partnerDetail.coupons.deactivate" />
      </Button>
      <Button
        data-tst="coupon-bulk-edit"
        disabled={busy}
        size="small"
        variant="contained"
        onClick={onEdit}
      >
        <FormattedMessage id="admin.partnerDetail.coupons.bulk.edit" />
      </Button>
      <Button
        disabled={busy}
        size="small"
        variant="text"
        onClick={onClear}
      >
        <FormattedMessage id="admin.partnerDetail.coupons.bulk.clear" />
      </Button>
    </div>
  </Paper>
)
